export enum StatTypes {
  SET_START_DATE = 'SET_START_DATE',
  SET_END_DATE = 'SET_END_DATE',
  FETCH_STATS = 'FETCH_STATS',
  EXPORT_CSV_TRAININGS_PER_TRANING_SUCCESS = 'EXPORT_CSV_TRAININGS_PER_TRANING_SUCCESS',
}
